module Eseebase {

    export class RoomTypeViewModel {
        id: string;
        organizationalUnitId: string;
        name: string;
        number: string;
        isOutdoorRoom: boolean;
        isLivingRoom: boolean;
        isEdit: boolean;
        isNew: boolean;
    }
}